<template>
  <b-card
    text-variant="center"
    class="card card-congratulations"
  >
    <!-- images -->
    <b-img
      :src="require('@/assets/images/elements/decore-left.png')"
      class="congratulations-img-left"
    />
    <b-img
      :src="require('@/assets/images/elements/decore-right.png')"
      class="congratulations-img-right"
    />
    <!--/ images -->

    <b-avatar
      variant="primary"
      size="70"
      class="shadow mb-2"
    >
      <feather-icon
        size="28"
        icon="AwardIcon"
      />
    </b-avatar>
    <h1 class="mb-1 mt-50 text-white">
      Congratulations {{ first_name }},
    </h1>
    <b-card-text class="m-auto w-75">
      You earned <strong>$ {{ last_30_days_earning }}</strong> within last
      30 days
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BAvatar, BCard, BCardText, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BAvatar,
    BImg,
    BCardText,
  },
  // eslint-disable-next-line vue/prop-name-casing
  props: ['first_name', 'last_30_days_earning'],
}
</script>
